import FAEventCardInformation from './FAEventCardInformation'
export default FAEventCardInformation
